/* AYP Predictive Search — autocomplete header (Section Rendering API).
   Recherche instantanée FA-style : Catégories + Produits + « Voir tous les résultats ».
   Léger, vanilla, sans dépendance. */
(function () {
  'use strict';

  var form = document.querySelector('[data-ayp-search-form]');
  if (!form) return;
  var input = form.querySelector('#ayp-header-search');
  var panel = form.querySelector('[data-ayp-predictive-results]');
  if (!input || !panel) return;

  // Portaler le panneau dans <body> : il échappe aux contextes d'empilement des
  // sections (sinon la nav .ayp-nav, plus bas dans le DOM, recouvre le dropdown).
  // Combiné à position:fixed (CSS), il reste au-dessus de tout.
  document.body.appendChild(panel);

  var BASE = form.getAttribute('data-predictive-url') || '/search/suggest';
  var MIN_CHARS = 2;
  var DEBOUNCE = 220;
  var SECTION = 'ayp-predictive-search';

  var timer = null;
  var controller = null;
  var options = [];
  var activeIndex = -1;
  var lastTerm = '';
  var isOpen = false;

  // Normalisation requête pour l'autocomplete : l'index prédictif Shopify ne
  // matche pas "rollup" (un mot) sur "Roll-up" (roll+up), alors qu'il matche
  // "roll up" via le titre. On réécrit donc rollup -> roll up (+ quelques
  // synonymes métier) AVANT l'appel /search/suggest. La page de résultats reste
  // native (tags). Étendre PSYN si d'autres termes posent souci.
  var PSYN = {
    rollup: 'roll up', rollups: 'roll up', 'roll-up': 'roll up', 'roll-ups': 'roll up',
    kakemono: 'roll up', 'kakémono': 'roll up', enrouleur: 'roll up',
    beachflag: 'beach flag', xbanner: 'x banner', tshirt: 't shirt',
    visitenkarten: 'cartes de visite', flyerdruck: 'flyer'
  };
  function psNormalize(t) {
    var k = (t || '').trim().toLowerCase();
    if (PSYN[k]) return PSYN[k];
    if (/[-_]/.test(t)) return t.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    return t;
  }

  function buildUrl(term) {
    return BASE +
      (BASE.indexOf('?') === -1 ? '?' : '&') +
      'q=' + encodeURIComponent(psNormalize(term)) +
      '&resources[type]=product,collection' +
      '&resources[limit]=6' +
      '&resources[limit_scope]=each' +
      '&section_id=' + SECTION;
  }

  // Positionne le panneau (fixed, dans body) juste sous la barre de recherche.
  function positionPanel() {
    var r = form.getBoundingClientRect();
    panel.style.top = (r.bottom + 8) + 'px';
    panel.style.left = r.left + 'px';
    panel.style.width = r.width + 'px';
  }

  function open() {
    positionPanel();
    if (isOpen) return;
    panel.hidden = false;
    isOpen = true;
    input.setAttribute('aria-expanded', 'true');
  }

  function close() {
    if (!isOpen && panel.hidden) return;
    panel.hidden = true;
    panel.innerHTML = '';
    isOpen = false;
    options = [];
    activeIndex = -1;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
  }

  function collectOptions() {
    options = Array.prototype.slice.call(panel.querySelectorAll('[data-ps-link]'));
    options.forEach(function (el, i) {
      if (!el.id) el.id = 'ayp-ps-opt-' + i;
      var li = el.closest('[role="option"]');
      if (li && !li.id) li.id = el.id + '-li';
    });
    activeIndex = -1;
  }

  function setActive(i) {
    if (!options.length) return;
    if (activeIndex > -1 && options[activeIndex]) {
      options[activeIndex].classList.remove('is-active');
      var prevLi = options[activeIndex].closest('[role="option"]');
      if (prevLi) prevLi.setAttribute('aria-selected', 'false');
    }
    activeIndex = (i + options.length) % options.length;
    var el = options[activeIndex];
    el.classList.add('is-active');
    var li = el.closest('[role="option"]');
    if (li) li.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', el.id);
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  function render(html) {
    var trimmed = (html || '').trim();
    if (!trimmed) { close(); return; }
    panel.innerHTML = trimmed;
    if (!panel.querySelector('.ayp-psearch__panel')) { close(); return; }
    panel.classList.remove('is-loading');
    collectOptions();
    open();
  }

  function fetchResults(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    panel.classList.add('is-loading');
    fetch(buildUrl(term), { signal: controller.signal })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (input.value.trim() !== term) return; // stale
        render(html);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        panel.classList.remove('is-loading');
        close();
      });
  }

  // Bouton « effacer » (croix custom) : visible seulement s'il y a du texte.
  var clearBtn = form.querySelector('[data-ayp-search-clear]');
  function toggleClear() {
    if (clearBtn) clearBtn.classList.toggle('is-visible', input.value.length > 0);
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      toggleClear();
      close();
      input.focus();
    });
  }
  toggleClear();

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('autocomplete', 'off');

  input.addEventListener('input', function () {
    toggleClear();
    var term = input.value.trim();
    lastTerm = term;
    clearTimeout(timer);
    if (term.length < MIN_CHARS) { close(); return; }
    timer = setTimeout(function () { fetchResults(term); }, DEBOUNCE);
  });

  input.addEventListener('focus', function () {
    var term = input.value.trim();
    if (term.length >= MIN_CHARS && !isOpen) {
      if (panel.querySelector('.ayp-psearch__panel')) { open(); }
      else { fetchResults(term); }
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      if (!isOpen && input.value.trim().length >= MIN_CHARS) { fetchResults(input.value.trim()); }
      else { e.preventDefault(); setActive(activeIndex + 1); }
    } else if (e.key === 'ArrowUp') {
      if (isOpen) { e.preventDefault(); setActive(activeIndex - 1); }
    } else if (e.key === 'Enter') {
      if (isOpen && activeIndex > -1 && options[activeIndex]) {
        e.preventDefault();
        window.location.href = options[activeIndex].getAttribute('href');
      }
    } else if (e.key === 'Escape') {
      if (isOpen) { e.preventDefault(); close(); }
    }
  });

  // Clic extérieur → fermer (le panneau est dans <body>, hors du form)
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target) && !panel.contains(e.target)) close();
  });

  // Repositionner le panneau quand on scrolle / redimensionne (il est fixed)
  window.addEventListener('scroll', function () { if (isOpen) positionPanel(); }, { passive: true });
  window.addEventListener('resize', function () { if (isOpen) positionPanel(); });

  // Empêche la fermeture quand on clique dans le panneau (avant navigation)
  panel.addEventListener('mousedown', function (e) {
    var link = e.target.closest('[data-ps-link]');
    if (link) return; // laisse le lien naviguer
  });
})();
